import {intcomma} from 'journalize';
import {select, selectAll} from 'd3-selection';
import {flyToCoords, flyToBbox} from '../methods/fly';
import {combineShapes} from '../methods/zoom';
import {getPerimeter} from '../layers/perimeters';
import {getEvacZoneBbox} from '../layers/evacuation-zones';


export const createFireLists = () => {
    // sort from biggest to smallest
    window.fireData.fireList.sort((a, b) => (a.acres < b.acres) ? 1 : -1);

    // Split the california fires from the ones other places
    const ca_fires = window.fireData.fireList.filter(f => f.sublist == 'ca');
    const other_fires = window.fireData.fireList.filter(f => f.sublist == 'other');

    let caPlural = 's';
    if(ca_fires.length === 1){
      caPlural = '';
    }

    let otherPlural = 's';
    if(other_fires.length === 1){
      otherPlural = '';
    }

    // Headlines
    document.querySelector('#ca-fires .head').innerHTML = `${ca_fires.length} California fire${caPlural}`;
    document.querySelector('#other-fires .head').innerHTML = `${other_fires.length} other fire${otherPlural}`;

    // Make the card lists
    createFireCards(ca_fires, 'ca-fires');
    createFireCards(other_fires, 'other-fires');
    insertRecirc();
};

const insertRecirc = () => {
  // window.RECIRC
  const recircCard = select('#ca-fires')
    .insert('div', '.fire-card:nth-child(7)')
    .classed('recirc', true);

  recircCard.append('h2')
    .html('More from The Times')

  recircCard.append('ul').selectAll('li')
    .data(window.RECIRC.articles)
    .enter()
    .append('li')
    .classed('links', true)
    .append('a')
    .attr('href', d => d.link)
    .html(d => d.title);
}

const createFireCards = (list, name) => {
  let fireCard = select('#fire-list')
    .select(`#${name}`)
    .selectAll('.fire-card')
    .data(list)
    .enter()
      .append('div')
      .classed('fire-card', true)
      .attr('id', d => `card-${d.slug}`)
      .attr('data-slug', d => d.slug)
      .attr('data-title', d => d.name)
      .attr('data-state', d => d.state)
      .attr('data-acres', d => d.acres)
      .attr('date-started', d => d.start_date)
      .attr('date-x', d => d.x)
      .attr('date-y', d => d.y)
      .attr('child-fires', d => d.complexFires ? d.complexFires.map(d => d.name) : null)
      .on('click', d => clickCard(d))

  const stats = fireCard.append('div')
    .classed('stats', true)

  stats.append('div')
    .classed('title', true)
    .html(d => d.name)

  stats.append('div')
    .classed('state', true)
    .html(d => d.state)

  stats.append('div')
    .classed('acres', true)
    .html(d => d.acres !== 0 ? `${intcomma(d.acres)} acres burned` : '')

  stats.append('div')
    .classed('started', true)
    .filter(d => d.start_date)
    .html(d => daysBurning(new Date(d.start_date)))

  stats.append('div')
    .filter(d => d.complexFires)
    .classed('children', true)
    .html(d => d.complexFires.length > 1 ? `Includes ${d.complexFires.length} fires` : `Includes 1 fire`)
    .on('click', d => {
      const children = select(`#card-${d.slug} .children`).node();
      const childList = select(`#card-${d.slug} .child-list`).node();
      if (childList.className === 'child-list show') {
          childList.className = "child-list";
          children.className = "children";
      } else {
          childList.className = "child-list show";
          children.className = "children show";
      }
    })

  stats.append('div')
    .classed('child-list', true)
    .filter(d => d.complexFires)
    .html(d => [...new Set(d.complexFires.map(d => d.name.trim()))].sort().join(', '))

  stats.append('div')
   .classed('pct-num', true)
    .html((d, i) => {
      if(d.containment){
        return i === 0 ? `${d.containment}% contained`: `${d.containment}%`;
      }
    });

  fireCard.append('div')
    .classed('pct', true)
    .style('width', d => {
      if(d.containment){
        return `${parseFloat(d.containment)}%`;
      } else {
        return '0%';
      }
    })
    .append('span');
};

const clickCard = (d) => {
  // Clear any existing active cards
  clearCards();

  // Make this card active
  const el = document.getElementById(`card-${d.slug}`);
  el.classList.add("active");

  const perimeter = getPerimeter(d.slug);
  const evacZoneBbox = getEvacZoneBbox(d.slug);
  if(perimeter && evacZoneBbox){
    const cShape = combineShapes(perimeter, evacZoneBbox);
    flyToBbox(cShape.geometry.coordinates[0]);
  } else if(evacZoneBbox){
    flyToBbox(evacZoneBbox.geometry.coordinates[0]);
  } else if(perimeter){
    // Fly to the fire perimeter
    flyToBbox(perimeter.properties.bbox);
  } else {
    // Fly to the fire
    flyToCoords(d.x, d.y);
  }

  // Scroll to the item in the list
  el.scrollIntoView({
    block: "start",
    behavior: "smooth"
  });

  window.history.replaceState('', 'California Fire Map', `${window.location.href.split('?')[0]}?fire=${d.slug}`);
};

export const daysBurning = date => {
    const nDate = new Date(date);
    const now = new Date();
    // To calculate the time difference of two dates
    const timeDiff = now.getTime() - nDate.getTime();
    // To calculate the no. of days between two dates
    const dayDiff = timeDiff / (1000 * 3600 * 24);
    // ${date.getMonth() + 1}/${date.getDate() + 1}/${date.getFullYear()}
    let days = 'days';
    if(Math.round(dayDiff) - 1 === 1){
      days = 'day';
    }
    if(Math.round(dayDiff) - 1 === 0){
      return 'Started today';
    } else {
      return `Burning for ${Math.round(dayDiff) - 1} ${days}`;
    }

}

export const clearCards = () => {
    const cards = document.querySelector('.fire-card.active');
    if (cards) cards.classList.remove("active");
}
